var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProjectListEmptyIllustration2026(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 183,
    viewBox: "25 0 200 246",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustrations"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Container"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Wrapper"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Section"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Large Illustration"
  }, /*#__PURE__*/React.createElement("g", {
    id: "illustration=async-scraper-service"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip_project_list_empty_2026)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.1,
    d: "M164.85 185.8C141.45 172.2 103.45 172.2 79.8503 185.8C56.3503 199.4 56.1503 221.4 79.5503 235C102.95 248.6 140.95 248.6 164.55 235C188.15 221.5 188.25 199.4 164.85 185.8Z",
    fill: "#5B5BA8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M181.35 199.7C181.35 199.4 181.35 199.1 181.45 198.8C181.45 198.6 181.45 198.4 181.45 198.2C181.45 198.1 181.45 197.9 181.45 197.8V188C181.45 188.3 181.45 188.7 181.45 189C181.45 189.3 181.45 189.6 181.35 189.9C181.35 190.2 181.25 190.4 181.25 190.7C181.25 191 181.15 191.3 181.15 191.6C181.15 191.9 181.05 192.1 180.95 192.4C180.85 192.7 180.85 193 180.75 193.3C180.65 193.6 180.55 193.8 180.55 194.1C180.45 194.4 180.35 194.7 180.25 195C180.15 195.3 180.05 195.5 179.95 195.8C179.85 196.1 179.75 196.4 179.55 196.7C179.45 197 179.35 197.2 179.15 197.5C179.05 197.8 178.85 198.1 178.75 198.4C178.65 198.6 178.45 198.9 178.35 199.1C178.15 199.4 177.95 199.8 177.75 200.1C177.65 200.3 177.45 200.6 177.25 200.8C177.05 201.1 176.75 201.5 176.55 201.8C176.35 202.1 176.15 202.4 175.95 202.6C175.85 202.7 175.75 202.8 175.65 202.9C175.25 203.4 174.95 203.8 174.45 204.2C174.35 204.3 174.35 204.3 174.25 204.4C173.85 204.8 173.55 205.2 173.15 205.6C173.05 205.7 172.95 205.8 172.85 205.9C172.55 206.2 172.25 206.5 171.95 206.7C171.75 206.9 171.45 207.1 171.25 207.4C170.95 207.7 170.65 207.9 170.25 208.2C169.95 208.4 169.75 208.6 169.45 208.8C169.15 209.1 168.75 209.3 168.35 209.6C168.05 209.8 167.85 210 167.55 210.2C167.15 210.5 166.75 210.7 166.35 211C166.05 211.2 165.85 211.3 165.55 211.5C164.85 211.9 164.15 212.4 163.45 212.8C162.55 213.3 161.55 213.9 160.55 214.3C160.25 214.4 160.05 214.6 159.75 214.7C158.95 215.1 158.05 215.5 157.25 215.9C157.05 216 156.85 216.1 156.65 216.2C155.65 216.6 154.55 217.1 153.55 217.4C153.25 217.5 153.05 217.6 152.75 217.7C151.85 218 151.05 218.3 150.15 218.6C149.85 218.7 149.55 218.8 149.25 218.9C148.85 219 148.35 219.2 147.95 219.3C147.55 219.4 147.05 219.6 146.65 219.7C146.25 219.8 145.75 219.9 145.35 220C144.95 220.1 144.45 220.2 143.95 220.3C143.55 220.4 143.05 220.5 142.65 220.6C142.15 220.7 141.75 220.8 141.25 220.9C140.75 221 140.35 221.1 139.85 221.2C139.45 221.3 138.95 221.4 138.55 221.4C137.45 221.6 136.35 221.8 135.15 221.9H135.05C133.95 222.1 132.85 222.2 131.75 222.3C131.35 222.3 130.95 222.4 130.55 222.4C129.95 222.5 129.25 222.5 128.65 222.6C128.25 222.6 127.85 222.7 127.45 222.7C126.85 222.7 126.15 222.8 125.55 222.8C125.15 222.8 124.75 222.8 124.25 222.9C123.75 222.9 123.15 222.9 122.65 222.9C122.25 222.9 121.75 222.9 121.35 222.9C120.75 222.9 120.25 222.9 119.65 222.9C119.25 222.9 118.75 222.9 118.35 222.9C117.85 222.9 117.35 222.9 116.85 222.8C116.35 222.8 115.95 222.8 115.45 222.7C114.95 222.7 114.45 222.6 113.95 222.6C113.45 222.6 113.05 222.5 112.55 222.5C112.05 222.5 111.55 222.4 111.05 222.4C110.55 222.4 110.15 222.3 109.65 222.3C109.15 222.2 108.65 222.2 108.15 222.1C107.75 222 107.25 222 106.85 221.9C106.25 221.8 105.65 221.7 104.95 221.6C104.65 221.5 104.25 221.5 103.95 221.4C103.15 221.3 102.45 221.1 101.75 221C101.55 221 101.35 220.9 101.15 220.9C100.15 220.7 99.1498 220.5 98.1498 220.2C97.8498 220.1 97.5498 220 97.2498 220C96.5498 219.8 95.8498 219.7 95.2498 219.5C94.9498 219.4 94.6498 219.3 94.3498 219.2C93.4498 218.9 92.5498 218.7 91.7498 218.4C91.4498 218.3 91.1498 218.2 90.9498 218.1C89.8498 217.7 88.8498 217.4 87.7498 217C87.2498 216.8 86.8498 216.6 86.4498 216.5C86.1498 216.4 85.7498 216.2 85.4498 216.1C84.9498 215.9 84.5498 215.7 84.0498 215.5C83.7498 215.4 83.4498 215.2 83.0498 215.1C82.5498 214.9 82.0498 214.6 81.5498 214.3C81.2498 214.2 81.0498 214 80.7498 213.9C80.0498 213.5 79.2498 213.1 78.5498 212.7C66.9498 205.9 61.1498 197.1 61.0498 188.3V198.1C61.0498 206.9 66.8498 215.8 78.5498 222.5C79.2498 222.9 80.0498 223.3 80.7498 223.7C81.0498 223.8 81.2498 224 81.5498 224.1C82.0498 224.4 82.5498 224.6 83.0498 224.9C83.3498 225 83.6498 225.2 83.9498 225.3C84.4498 225.5 84.8498 225.7 85.3498 225.9C85.6498 226 86.0498 226.2 86.3498 226.3C86.7498 226.5 87.1498 226.6 87.5498 226.8H87.6498C88.6498 227.2 89.7498 227.6 90.8498 227.9C91.1498 228 91.3498 228.1 91.6498 228.2C92.5498 228.5 93.3498 228.7 94.2498 229C94.4498 229.1 94.6498 229.1 94.7498 229.2C94.8498 229.2 94.9498 229.3 95.1498 229.3C95.8498 229.5 96.4498 229.7 97.1498 229.8C97.4498 229.9 97.7498 230 98.0498 230C99.0498 230.2 100.05 230.5 101.05 230.7C101.25 230.7 101.45 230.8 101.65 230.8C102.35 230.9 103.15 231.1 103.95 231.2C104.25 231.3 104.65 231.3 105.05 231.4C105.65 231.5 106.25 231.6 106.85 231.7C106.95 231.7 106.95 231.7 107.05 231.7C107.45 231.8 107.75 231.8 108.15 231.8C108.65 231.9 109.15 231.9 109.65 232C110.05 232 110.55 232.1 110.95 232.1C111.45 232.1 111.95 232.2 112.45 232.2C112.55 232.2 112.65 232.2 112.75 232.2C113.15 232.2 113.45 232.2 113.85 232.3C114.35 232.3 114.85 232.4 115.35 232.4C115.85 232.4 116.25 232.4 116.75 232.5C117.25 232.5 117.75 232.5 118.25 232.6C118.35 232.6 118.45 232.6 118.55 232.6C118.85 232.6 119.25 232.6 119.55 232.6C120.05 232.6 120.65 232.6 121.15 232.6C121.55 232.6 122.05 232.6 122.45 232.6C122.95 232.6 123.55 232.6 124.05 232.6C124.25 232.6 124.35 232.6 124.55 232.6C124.85 232.6 125.05 232.6 125.35 232.6C125.95 232.6 126.65 232.5 127.25 232.5C127.65 232.5 128.05 232.4 128.45 232.4C129.05 232.4 129.75 232.3 130.35 232.2C130.65 232.2 130.85 232.2 131.15 232.1C131.25 232.1 131.45 232.1 131.55 232.1C132.65 232 133.75 231.9 134.85 231.7H134.95C136.05 231.5 137.15 231.4 138.35 231.2C138.45 231.2 138.55 231.2 138.75 231.1C139.05 231 139.35 231 139.65 230.9C140.15 230.8 140.55 230.7 141.05 230.6C141.55 230.5 141.95 230.4 142.45 230.3C142.95 230.2 143.35 230.1 143.85 230C144.35 229.9 144.75 229.8 145.25 229.7C145.65 229.6 146.15 229.5 146.55 229.4C146.95 229.3 147.45 229.1 147.85 229C148.25 228.9 148.75 228.7 149.15 228.6C149.25 228.6 149.45 228.5 149.55 228.5C149.75 228.4 149.85 228.4 150.05 228.3C150.95 228 151.75 227.7 152.65 227.4C152.95 227.3 153.15 227.2 153.45 227.1C154.55 226.7 155.55 226.3 156.55 225.9C156.75 225.8 156.95 225.7 157.15 225.6C158.05 225.2 158.85 224.8 159.65 224.4C159.95 224.3 160.15 224.1 160.45 224C161.45 223.5 162.35 223 163.35 222.5C164.05 222.1 164.75 221.7 165.35 221.3C165.35 221.3 165.35 221.3 165.45 221.3C165.75 221.1 165.95 221 166.25 220.8C166.65 220.5 167.05 220.3 167.45 220C167.75 219.8 167.95 219.6 168.25 219.4C168.65 219.1 168.95 218.9 169.35 218.6C169.65 218.4 169.85 218.2 170.15 218C170.45 217.7 170.75 217.5 171.15 217.2C171.35 217 171.65 216.8 171.85 216.5C172.05 216.3 172.35 216.1 172.55 215.9C172.65 215.8 172.65 215.8 172.75 215.7C172.85 215.6 172.95 215.5 173.05 215.4C173.45 215 173.85 214.6 174.15 214.2C174.25 214.1 174.25 214.1 174.35 214C174.75 213.6 175.15 213.1 175.55 212.7C175.65 212.6 175.75 212.5 175.85 212.4C175.95 212.3 176.05 212.1 176.15 212C176.25 211.9 176.35 211.7 176.45 211.6C176.65 211.3 176.95 210.9 177.15 210.6C177.35 210.4 177.45 210.1 177.65 209.9C177.85 209.6 178.05 209.2 178.25 208.9C178.35 208.8 178.45 208.6 178.55 208.5C178.65 208.4 178.65 208.3 178.65 208.2C178.85 207.9 178.95 207.6 179.05 207.3C179.15 207 179.35 206.8 179.45 206.5C179.55 206.2 179.65 205.9 179.85 205.6C179.95 205.4 180.05 205.2 180.05 205.1C180.05 205 180.15 204.9 180.15 204.8C180.25 204.5 180.35 204.2 180.45 203.9C180.55 203.6 180.65 203.4 180.65 203.1C180.75 202.8 180.75 202.5 180.85 202.2C180.85 202 180.95 201.8 180.95 201.6C180.95 201.5 180.95 201.4 180.95 201.4C181.05 201.1 181.05 200.8 181.05 200.5C181.35 200.3 181.35 200 181.35 199.7Z",
    fill: "white",
    stroke: "#5B5BA8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M79.0497 163.7C102.55 150.1 140.65 150.1 164.05 163.7C187.45 177.3 187.35 199.3 163.75 212.9C140.25 226.5 102.15 226.5 78.7497 212.9C55.3497 199.3 55.4497 177.3 79.0497 163.7Z",
    fill: "#E6E7FF",
    stroke: "#5B5BA8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M114.45 185.6C114.45 185.6 119.45 182.5 120.25 182.2C121.05 182 128.35 178.7 136.05 180.8C143.75 182.9 146.35 186.6 145.95 190C145.55 193.4 141.05 195.8 140.65 196.1C140.25 196.4 132.25 200.9 132.25 200.9",
    stroke: "#5B5BA8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M128.249 190.4C128.249 190.4 123.249 193.5 122.449 193.8C121.649 194 114.349 197.3 106.649 195.2C98.9494 193.1 96.3494 189.4 96.7494 186C97.1494 182.6 101.649 180.2 102.049 179.9C102.449 179.6 110.449 175.1 110.449 175.1",
    stroke: "#5B5BA8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M118.949 176.2C118.949 176.2 105.949 183.8 105.649 184.2C105.249 184.7 103.049 187.1 105.849 189.4C109.149 192.1 115.849 191.5 120.049 188.7C124.149 185.8 132.249 182.1 137.449 187.3C140.749 190.6 133.149 194.2 133.149 194.2L122.649 200.4",
    stroke: "#5B5BA8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M125.65 176.2C123.85 177.2 120.85 177.3 119.05 176.2C117.25 175.1 117.25 173.4 119.05 172.4C120.85 171.3 123.85 171.3 125.65 172.4C127.45 173.5 127.55 175.1 125.65 176.2Z",
    fill: "white",
    stroke: "#5B5BA8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M122.349 204C120.549 205 117.549 205.1 115.749 204C113.949 202.9 113.949 201.2 115.749 200.2C117.549 199.1 120.549 199.1 122.349 200.2C124.249 201.3 124.249 203 122.349 204Z",
    fill: "white",
    stroke: "#5B5BA8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M160.45 187.6V202.9",
    stroke: "#5B5BA8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M160.45 174.6V181.5",
    stroke: "#5B5BA8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M78.9502 160.1V169.6",
    stroke: "#5B5BA8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M89.4502 173.8V189.3",
    stroke: "#5B5BA8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M151.149 152.5V168.1",
    stroke: "#5B5BA8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M82.649 108.2L66.249 98.6998V79.7998L82.549 89.2998L82.649 108.2Z",
    fill: "white",
    stroke: "#5B5BA8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M82.549 89.2998L66.249 79.7998L82.649 70.2998L99.049 79.7998L82.549 89.2998Z",
    fill: "#7A2EFF",
    stroke: "#5B5BA8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M99.0498 79.7998V98.6998L82.6498 108.2L82.5498 89.2998L99.0498 79.7998Z",
    fill: "white",
    stroke: "#5B5BA8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M51.1502 143L42.9502 138.3V128.8L51.1502 133.6V143Z",
    fill: "white",
    stroke: "#5B5BA8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M51.1502 133.6L42.9502 128.8L51.1502 124.1L59.3502 128.8L51.1502 133.6Z",
    fill: "white",
    stroke: "#5B5BA8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M59.3494 128.8V138.3L51.1494 143V133.6L59.3494 128.8Z",
    fill: "white",
    stroke: "#5B5BA8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M190.551 158.9L182.351 154.2V144.7L190.451 149.5L190.551 158.9Z",
    fill: "white",
    stroke: "#5B5BA8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M190.451 149.5L182.351 144.7L190.551 140L198.651 144.7L190.451 149.5Z",
    fill: "white",
    stroke: "#5B5BA8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M198.65 144.7L198.75 154.2L190.55 158.9L190.45 149.5L198.65 144.7Z",
    fill: "white",
    stroke: "#5B5BA8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M121.25 178L100.15 165.8L100.05 141.3L121.25 153.6V178Z",
    fill: "white",
    stroke: "#5B5BA8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M121.25 153.6L100.05 141.3L121.35 129L142.55 141.3L121.25 153.6Z",
    fill: "#7A2EFF",
    stroke: "#5B5BA8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M142.549 141.3V165.7L121.249 178V153.6L142.549 141.3Z",
    fill: "white",
    stroke: "#5B5BA8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M160.75 90.4001L146.05 81.8001L145.95 64.7001L160.75 73.3001V90.4001Z",
    fill: "white",
    stroke: "#5B5BA8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M160.75 73.3001L145.95 64.7001L160.85 56.1001L175.65 64.7001L160.75 73.3001Z",
    fill: "#7A2EFF",
    stroke: "#5B5BA8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M175.651 64.7002V81.8002L160.751 90.4002V73.3002L175.651 64.7002Z",
    fill: "white",
    stroke: "#5B5BA8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M82.6494 79.7999V13.3999",
    stroke: "#5B5BA8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M160.749 66.8V0.5",
    stroke: "#5B5BA8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M120.55 142.9V76.5",
    stroke: "#5B5BA8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M120.55 69.5V54.1",
    stroke: "#5B5BA8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M160.749 130.9V87.7998",
    stroke: "#5B5BA8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M82.5498 147.1V104.1",
    stroke: "#5B5BA8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M222.149 69.3998L177.849 94.9998C176.649 95.6998 175.649 97.3998 175.649 98.7998V113.6C175.649 115 176.649 115.6 177.849 114.9L222.249 89.2998C223.449 88.5998 224.449 86.8998 224.449 85.4998V70.6998C224.449 69.1998 223.449 68.6998 222.149 69.3998Z",
    fill: "white",
    stroke: "#5B5BA8",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_31"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M184.551 102.8L187.151 98.5997C187.151 98.4997 187.251 98.4997 187.251 98.4997C187.351 98.4997 187.351 98.4997 187.351 98.4997C187.451 98.4997 187.451 98.6997 187.351 98.7997L184.651 103.2C184.651 103.3 184.551 103.3 184.551 103.3H184.451L183.251 102.6C183.151 102.6 183.151 102.4 183.251 102.3C183.251 102.2 183.351 102.2 183.351 102.2H183.451L184.551 102.8ZM185.351 97.1997C184.351 97.7997 183.451 98.6997 182.851 99.7997C182.251 100.9 181.851 102.2 181.851 103.3C181.851 104.4 182.251 105.2 182.851 105.6C183.451 106 184.351 105.9 185.351 105.3C186.351 104.7 187.251 103.8 187.851 102.7C188.451 101.6 188.851 100.3 188.851 99.1997L189.051 99.0997L188.851 99.1997C188.851 98.0997 188.451 97.2997 187.851 96.8997C187.151 96.4997 186.251 96.5997 185.351 97.1997Z",
    fill: "#7A2EFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M185.35 96.6996C183.15 97.8996 181.45 101 181.45 103.5C181.45 106 183.25 107 185.35 105.7C187.55 104.5 189.25 101.4 189.25 98.8996L189.05 98.9996L188.85 99.0996C188.85 100.2 188.45 101.5 187.85 102.6C187.25 103.7 186.35 104.7 185.35 105.2C184.35 105.8 183.45 105.8 182.85 105.5C182.25 105.1 181.85 104.3 181.85 103.2C181.85 102.1 182.25 100.8 182.85 99.6996C183.45 98.5996 184.35 97.5996 185.35 97.0996C186.35 96.4996 187.25 96.4996 187.85 96.7996C188.45 97.1996 188.85 97.9996 188.85 99.0996L189.05 98.9996L189.25 98.8996C189.25 96.4996 187.45 95.4996 185.35 96.6996Z",
    fill: "#5B5BA8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M212.55 83.6996L193.25 94.7996C193.15 94.8996 193.05 94.9996 193.05 95.0996C193.05 95.1996 193.15 95.2996 193.25 95.1996L212.55 84.0996C212.65 83.9996 212.75 83.8996 212.75 83.7996C212.75 83.6996 212.65 83.5996 212.55 83.6996Z",
    fill: "#5B5BA8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M204.949 90.9994L193.349 97.6994C193.249 97.7994 193.149 97.8994 193.149 97.9994C193.149 98.0994 193.249 98.1994 193.349 98.0994L204.949 91.3994C205.049 91.2994 205.149 91.1994 205.149 91.0994C205.149 90.9994 205.049 90.8994 204.949 90.9994Z",
    fill: "#5B5BA8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M187.25 98.4995L187.15 98.5995L184.55 102.8L183.45 102.2H183.35L183.25 102.3C183.15 102.4 183.15 102.6 183.25 102.6L184.45 103.3H184.55L184.65 103.2L187.35 98.7995C187.45 98.6995 187.45 98.4995 187.35 98.4995H187.25Z",
    fill: "white"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M72.1498 25.9L27.7498 51.5C26.5498 52.2 25.5498 53.9 25.5498 55.3V70.1C25.5498 71.5 26.5498 72.1 27.7498 71.4L72.1498 45.8C73.3498 45.1 74.3498 43.4 74.3498 42V27.2C74.3498 25.8 73.3498 25.2 72.1498 25.9Z",
    fill: "white",
    stroke: "#5B5BA8",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_35"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M34.451 59.2999L37.051 55.0999C37.051 54.9999 37.151 54.9999 37.151 54.9999C37.251 54.9999 37.251 54.9999 37.251 54.9999C37.351 54.9999 37.351 55.1999 37.251 55.2999L34.551 59.6999C34.551 59.7999 34.451 59.7999 34.451 59.7999H34.351L33.051 59.1999C33.051 59.0999 33.051 58.9999 33.051 58.8999C33.051 58.7999 33.151 58.7999 33.151 58.7999H33.251L34.451 59.2999ZM35.251 53.6999C34.251 54.2999 33.351 55.1999 32.751 56.2999C32.151 57.3999 31.751 58.6999 31.751 59.7999C31.751 60.8999 32.151 61.6999 32.751 62.0999C33.351 62.4999 34.251 62.3999 35.251 61.7999C36.251 61.1999 37.151 60.2999 37.751 59.1999C38.351 58.0999 38.751 56.7999 38.751 55.6999L38.951 55.5999L38.751 55.6999C38.751 54.5999 38.351 53.7999 37.751 53.3999C37.151 53.0999 36.251 53.0999 35.251 53.6999Z",
    fill: "#7A2EFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M35.2506 53.3C33.0506 54.5 31.3506 57.5 31.3506 60C31.3506 62.5 33.1506 63.5 35.2506 62.2C37.4506 61 39.1506 57.9 39.1506 55.4L38.9506 55.5L38.7506 55.6C38.7506 56.7 38.3506 58 37.7506 59.1C37.1506 60.2 36.2506 61.2 35.2506 61.7C34.2506 62.3 33.3506 62.3 32.7506 62C32.1506 61.6 31.7506 60.8 31.7506 59.7C31.7506 58.6 32.1506 57.3 32.7506 56.2C33.3506 55.1 34.2506 54.1 35.2506 53.6C36.2506 53 37.1506 53 37.7506 53.3C38.3506 53.7 38.7506 54.5 38.7506 55.6L38.9506 55.5L39.1506 55.4C39.1506 53 37.4506 52 35.2506 53.3Z",
    fill: "#5B5BA8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M62.5498 40.2L43.2498 51.4C43.1498 51.5 43.0498 51.6 43.0498 51.7C43.0498 51.8 43.1498 51.9 43.2498 51.7999L62.5498 40.7C62.6498 40.6 62.7498 40.5 62.7498 40.4C62.7498 40.2 62.6498 40.2 62.5498 40.2Z",
    fill: "#5B5BA8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M54.8498 47.5002L43.2498 54.2002C43.1498 54.3002 43.0498 54.4002 43.0498 54.5002C43.0498 54.6002 43.1498 54.7002 43.2498 54.6002L54.8498 47.9002C54.9498 47.8002 55.0498 47.7002 55.0498 47.6002C55.0498 47.5002 54.9498 47.4002 54.8498 47.5002Z",
    fill: "#5B5BA8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M37.1498 54.9998L37.0498 55.0998L34.4498 59.2998L33.3498 58.6998H33.2498L33.1498 58.7998C33.0498 58.9998 33.0498 59.0998 33.0498 59.1998L34.2498 59.8998H34.3498L34.4498 59.7998L37.1498 55.3998C37.2498 55.2998 37.2498 55.0998 37.1498 55.0998C37.2498 54.9998 37.2498 54.9998 37.1498 54.9998Z",
    fill: "white"
  }))))))))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_project_list_empty_2026"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 199.9,
    height: 245.2,
    fill: "white",
    transform: "translate(25.0498)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectListEmptyIllustration2026);
export default __webpack_public_path__ + "static/media/project-list-empty-illustration-2026.7d69a297c4ca575855dfb49829b90fe3.svg";
export { ForwardRef as ReactComponent };